import * as MemoryCache from 'memory-cache';
import * as queryString from 'querystring';
import TokenResponse from 'owa-service/lib/contract/TokenResponse';
import TokenResponseCode from 'owa-service/lib/contract/TokenResponseCode';
import AuthenticationUrlResponseCode from 'owa-service/lib/contract/AuthenticationUrlResponseCode';
import getAuthenticationUrlOperation from 'owa-service/lib/operation/getAuthenticationUrlOperation';
import { getCachedToken } from './getAccessTokenforResource';
import {
    fetchDelegationAccessTokenFromMsa,
    Options,
} from 'owa-tokenprovider/lib/fetchDelegationAccessTokenFromMsa';

let cache: MemoryCache = null;

export async function getDelegationTokenForOwa(scope: string): Promise<string | undefined> {
    let options: Options = {
        scope: scope,
        client_id: '',
        authorization_uri: '',
        redirect_uri: '',
    };
    let accessToken: string | undefined = undefined;
    let response = await getAuthenticationUrlOperation();

    if (
        response.ResultCode != AuthenticationUrlResponseCode.Success ||
        response.ImplicitGrantAuthorizationUrl == null ||
        response.ImplicitGrantAuthorizationUrl == ''
    ) {
        return accessToken;
    }

    let queryParams = queryString.parse(response.ImplicitGrantAuthorizationUrl.split('?')[1] || '');
    if (queryParams.client_id && queryParams.redirect_uri) {
        options.client_id = queryParams.client_id;
        options.authorization_uri = response.ImplicitGrantAuthorizationUrl.split('?')[0];
        options.redirect_uri = queryParams.redirect_uri;
        accessToken = await getDelegationToken(options);
    }

    return accessToken;
}

export async function getDelegationToken(opts: Options): Promise<string | undefined> {
    let cacheKey = opts.client_id + opts.scope;
    let tokenResponse = getCachedToken(getCache(), cacheKey);

    if (tokenResponse == null) {
        tokenResponse = await fetchDelegationAccessTokenFromMsa(opts);
        cacheToken(cacheKey, tokenResponse);
    }

    return tokenResponse.TokenResultCode == TokenResponseCode.Success
        ? tokenResponse.AccessToken
        : undefined;
}

export function cacheToken(cacheKey: string, tokenResponse: TokenResponse) {
    if (
        tokenResponse &&
        tokenResponse.TokenResultCode == TokenResponseCode.Success &&
        tokenResponse.AccessTokenExpiry
    ) {
        const cacheTimeout = new Date(tokenResponse.AccessTokenExpiry).getTime() - Date.now();
        if (cacheTimeout > 0) {
            getCache().put(cacheKey, tokenResponse, cacheTimeout);
        }
    }
}

export function initializeTokenProvider(cacheObject: MemoryCache): void {
    cache = cacheObject;
}

function getCache(): MemoryCache {
    if (cache == null) {
        cache = new MemoryCache.Cache();
    }

    return cache;
}
